"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _SectionRowInventories = _interopRequireDefault(require("@/flow/plantNursery/components/SectionRowInventories.vue"));
var _plantNursery = require("@/services/plant-nursery.service");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LOT_TYPE_OPTIONS = [{
  value: 'graft',
  label: 'Enxertia'
}, {
  value: 'cut',
  label: 'Estaquia'
}];
var _default = exports.default = {
  name: 'CreateLotPage',
  components: {
    Page: _Page.default,
    SectionRowInventories: _SectionRowInventories.default
  },
  data: function data() {
    return {
      isSubmitting: false,
      form: this.createDefaultForm(),
      varieties: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    page: 'menuItemsPlantsNursery',
    farm: 'GET_FARM'
  })), {}, {
    varietyOptions: function varietyOptions() {
      var items = Array.isArray(this.varieties) ? this.varieties : [];
      if (this.form.type === 'cut') {
        return items.filter(function (v) {
          return (v === null || v === void 0 ? void 0 : v.type) === 'scion';
        });
      }
      return items;
    },
    lotTypeOptions: function lotTypeOptions() {
      return LOT_TYPE_OPTIONS;
    },
    isGraftingType: function isGraftingType() {
      return this.form.type === LOT_TYPE_OPTIONS[0].value;
    },
    varietyFieldLabel: function varietyFieldLabel() {
      return this.isGraftingType ? 'Variedade do cavalo' : 'Variedade da estaquia';
    }
  }),
  mounted: function mounted() {
    this.loadVarietiesOnce();
  },
  watch: {
    'form.type': function formType() {
      this.form.varietyId = null;
    }
  },
  methods: {
    loadVarietiesOnce: function () {
      var _loadVarietiesOnce = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm, params, _yield$plantNurserySe, response, items, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                page: 1,
                limit: 200,
                farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id
              };
              _context.n = 1;
              return _plantNursery.plantNurseryService.fetchVarieties(params);
            case 1:
              _yield$plantNurserySe = _context.v;
              response = _yield$plantNurserySe.data;
              items = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
              this.varieties = items;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.varieties = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadVarietiesOnce() {
        return _loadVarietiesOnce.apply(this, arguments);
      }
      return loadVarietiesOnce;
    }(),
    createDefaultForm: function createDefaultForm() {
      return {
        type: LOT_TYPE_OPTIONS[0].value,
        varietyId: null,
        date: new Date(),
        inventories: []
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$router.push({
        name: 'plant-nursery-lots'
      });
    },
    validateForm: function validateForm() {
      var _this$form$inventorie;
      if (!this.form.type) {
        this.$buefy.toast.open({
          message: 'Selecione o tipo de lote.',
          type: 'is-danger'
        });
        return false;
      }
      if (!this.form.varietyId) {
        this.$buefy.toast.open({
          message: "Selecione ".concat(this.varietyFieldLabel.toLowerCase(), "."),
          type: 'is-danger'
        });
        return false;
      }
      if (!((_this$form$inventorie = this.form.inventories) !== null && _this$form$inventorie !== void 0 && _this$form$inventorie.length)) {
        this.$buefy.toast.open({
          message: 'Adicione pelo menos um local.',
          type: 'is-danger'
        });
        return false;
      }
      for (var i = 0; i < this.form.inventories.length; i++) {
        var _inv$quantity;
        var inv = this.form.inventories[i];
        if (!inv.rowId) {
          this.$buefy.toast.open({
            message: "Selecione a rua para o local ".concat(i + 1, "."),
            type: 'is-danger'
          });
          return false;
        }
        var quantity = Number((_inv$quantity = inv.quantity) !== null && _inv$quantity !== void 0 ? _inv$quantity : 0);
        if (!Number.isFinite(quantity) || quantity <= 0) {
          this.$buefy.toast.open({
            message: "Informe a quantidade para o local ".concat(i + 1, "."),
            type: 'is-danger'
          });
          return false;
        }
      }
      return true;
    },
    buildPayload: function buildPayload() {
      var _this$farm2;
      var varietyId = Number(this.form.varietyId);
      var payload = {
        farmId: (_this$farm2 = this.farm) === null || _this$farm2 === void 0 ? void 0 : _this$farm2.id,
        date: this.form.date ? new Date(this.form.date).toISOString() : new Date().toISOString(),
        inventories: this.form.inventories.map(function (inv) {
          return {
            rowId: Number(inv.rowId),
            quantity: Number(inv.quantity)
          };
        })
      };
      if (this.isGraftingType) {
        payload.rootstockId = Number.isFinite(varietyId) ? varietyId : this.form.varietyId;
      } else {
        payload.cuttingId = Number.isFinite(varietyId) ? varietyId : this.form.varietyId;
      }
      return payload;
    },
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var payload, _error$response, _error$response$data, message, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.validateForm()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              payload = this.buildPayload();
              this.isSubmitting = true;
              _context2.p = 2;
              if (!this.isGraftingType) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return _plantNursery.plantNurseryService.createGraftingLot(payload);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.n = 5;
              return _plantNursery.plantNurseryService.createCuttingLot(payload);
            case 5:
              this.$buefy.toast.open({
                message: 'Lote registrado com sucesso.',
                type: 'is-success'
              });
              this.resetForm();
              this.$router.push({
                name: 'plant-nursery-lots'
              });
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              message = (_t2 === null || _t2 === void 0 ? void 0 : (_error$response = _t2.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Não foi possível registrar o lote.';
              this.$buefy.toast.open({
                message: message,
                type: 'is-danger'
              });
            case 7:
              _context2.p = 7;
              this.isSubmitting = false;
              return _context2.f(7);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 6, 7, 8]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
  }
};